(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-collection-nav"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll(".highlights-banner__block").forEach(function (el) {
    el.addEventListener("click", function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const targetID = el.getAttribute("data-id");
      document.getElementById(targetID).scrollIntoView();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
